import { staticText } from '../../../utils/translations/staticText';

export default staticText({
  chooseSsReward: {
    _: '1. Choose Your MoneyMax Reward',
  },
  brand_reward_guidance: {
    _: "MoneyMax's reward",
    zh: 'MoneyMax 獨家獎勵',
  },
});
